var map = {
	"./028-madeira.svg": "004c",
	"./034-tibet.svg": "444c",
	"./037-nato.svg": "037a",
	"./061-sardinia.svg": "20d9",
	"./065-azores islands.svg": "1493",
	"./086-melilla.svg": "50c2",
	"./091-ossetia.svg": "cf9b",
	"./094-saba island.svg": "c807",
	"./100-somaliland.svg": "dcc7",
	"./105-transnistria.svg": "0380",
	"./107-orkney islands.svg": "7f5a",
	"./122-Rapa Nui.svg": "d8f1",
	"./126-galapagos islands.svg": "5b33",
	"./139-british columbia.svg": "8c72",
	"./142-basque country.svg": "8f47",
	"./153-bonaire.svg": "bf31",
	"./157-aland islands.svg": "b5e6",
	"./161-balearic islands.svg": "3b37",
	"./162-abkhazia.svg": "ae8f",
	"./173-canary islands.svg": "caa0",
	"./174-corsica.svg": "72e4",
	"./178-ceuta.svg": "146f",
	"./217-united nations.svg": "8163",
	"./227-scotland.svg": "c6dc",
	"./239-hawaii.svg": "39c2",
	"./246-wales.svg": "9984",
	"./252-european union.svg": "d13d",
	"./ad.svg": "0021",
	"./ae.svg": "2ad8",
	"./af.svg": "9c0b",
	"./ag.svg": "d41f",
	"./ai.svg": "16b6",
	"./al.svg": "da06",
	"./am.svg": "7f0c",
	"./an.svg": "0358",
	"./ao.svg": "f937",
	"./ar.svg": "1c82",
	"./as.svg": "0d89",
	"./at.svg": "c84f",
	"./au.svg": "c072",
	"./aw.svg": "91c9",
	"./az.svg": "dca1",
	"./ba.svg": "8b73",
	"./bb.svg": "16bd",
	"./bd.svg": "9a99",
	"./be.svg": "887d",
	"./bf.svg": "b8bb",
	"./bg.svg": "b9ea",
	"./bh.svg": "e44b",
	"./bi.svg": "0a70",
	"./bj.svg": "fa9d",
	"./bl.svg": "5f52",
	"./bm.svg": "c85c",
	"./bn.svg": "5343",
	"./bo.svg": "cea0",
	"./bq.svg": "76f1",
	"./br.svg": "dcbb",
	"./bs.svg": "1125",
	"./bt 1.svg": "5bfd",
	"./bt.svg": "4f64",
	"./bw.svg": "2128",
	"./by.svg": "84cf",
	"./bz.svg": "9d30",
	"./ca.svg": "2beb",
	"./cc.svg": "226e",
	"./cd.svg": "fa26",
	"./cf.svg": "d0c1",
	"./cg.svg": "4149",
	"./ch.svg": "2e2d",
	"./ci.svg": "beef",
	"./ck.svg": "ac42",
	"./cl.svg": "e815",
	"./cm.svg": "cfc0b",
	"./cn.svg": "4ead",
	"./co.svg": "f603",
	"./cr.svg": "6ad9",
	"./cu.svg": "ab84",
	"./cv.svg": "3737",
	"./cw.svg": "2330",
	"./cx.svg": "3ac8",
	"./cy 2.svg": "1069",
	"./cy.svg": "2a21",
	"./cz.svg": "e4af",
	"./de.svg": "a3cd",
	"./dj.svg": "47dc",
	"./dk.svg": "07c2",
	"./dm.svg": "a475",
	"./do.svg": "1edc",
	"./dz.svg": "1ec7",
	"./ec.svg": "6b4e",
	"./ee.svg": "b5da",
	"./eg.svg": "cd82",
	"./eh.svg": "263d",
	"./er.svg": "5284",
	"./es.svg": "fdce",
	"./et.svg": "fbab",
	"./fi.svg": "d43e",
	"./fj.svg": "e45b",
	"./fk.svg": "0b28",
	"./fm.svg": "a668",
	"./fo.svg": "d471",
	"./fr.svg": "6ae4",
	"./ga.svg": "706f",
	"./gb 2.svg": "eace",
	"./gb.svg": "e13f",
	"./gd.svg": "6e81",
	"./ge.svg": "7076",
	"./gg.svg": "8270",
	"./gh.svg": "9e16",
	"./gi.svg": "9979",
	"./gl.svg": "4828",
	"./gm.svg": "b894",
	"./gn.svg": "d329",
	"./gq.svg": "4782",
	"./gr.svg": "2f94",
	"./gt.svg": "a765",
	"./gu.svg": "8056",
	"./gw.svg": "f30a",
	"./gy.svg": "d451",
	"./hk.svg": "4e07",
	"./hn.svg": "77f9",
	"./hr.svg": "43f7",
	"./ht.svg": "931b",
	"./hu.svg": "c498",
	"./id.svg": "0648",
	"./ie.svg": "99c0",
	"./il.svg": "7674",
	"./im.svg": "523c",
	"./in.svg": "67e3",
	"./io.svg": "d324",
	"./iq.svg": "e9d9",
	"./ir.svg": "ca50",
	"./is.svg": "1bf5",
	"./it.svg": "273b",
	"./je.svg": "593a",
	"./jm.svg": "6ce7",
	"./jo.svg": "bf61",
	"./jp.svg": "7350",
	"./ke.svg": "6800",
	"./kg.svg": "043d",
	"./kh.svg": "c0b7",
	"./ki.svg": "6efb",
	"./km.svg": "2e89",
	"./kn.svg": "0b44",
	"./kp.svg": "80ce",
	"./kr.svg": "151b",
	"./kw.svg": "9fca",
	"./ky.svg": "1be6",
	"./kz.svg": "4065",
	"./la.svg": "5ca7",
	"./lb.svg": "d4ef",
	"./lc.svg": "cb29",
	"./li.svg": "4279",
	"./lk.svg": "3d1e",
	"./lr.svg": "9dfc",
	"./ls.svg": "8657",
	"./lt.svg": "262c",
	"./lu.svg": "e171",
	"./lv.svg": "cc45",
	"./ly.svg": "35cd",
	"./ma.svg": "adbb",
	"./mc.svg": "d93b",
	"./md.svg": "5a3b",
	"./me.svg": "d543",
	"./mf.svg": "1587",
	"./mg.svg": "1b61",
	"./mh.svg": "4a47",
	"./mk.svg": "0f6e",
	"./ml.svg": "a103",
	"./mm.svg": "110b",
	"./mn.svg": "5393",
	"./mo.svg": "3d8f",
	"./mp.svg": "3cee",
	"./mq.svg": "7ad5",
	"./mr.svg": "a882",
	"./ms.svg": "550d",
	"./mt.svg": "9712",
	"./mu.svg": "bc72f",
	"./mv.svg": "e4a2",
	"./mw.svg": "1b26",
	"./mx.svg": "7c2a",
	"./my.svg": "5761",
	"./mz.svg": "0db3",
	"./na.svg": "fd9e",
	"./nc.svg": "653c",
	"./ne.svg": "feb6",
	"./nf.svg": "c1ec",
	"./ng.svg": "076a",
	"./ni.svg": "5777",
	"./nl.svg": "0163",
	"./no.svg": "8b06",
	"./np.svg": "fdbc4",
	"./nr.svg": "6b37",
	"./nu.svg": "0e1b",
	"./nz.svg": "c0d9",
	"./om.svg": "d1e8",
	"./pa.svg": "b049",
	"./pe.svg": "db4c",
	"./pf.svg": "9755",
	"./pg.svg": "5efc",
	"./ph.svg": "d1a1",
	"./pk.svg": "b2ba",
	"./pl.svg": "6f7c",
	"./pm.svg": "2846",
	"./pn.svg": "6423",
	"./pr.svg": "27c8",
	"./ps.svg": "636e",
	"./pt.svg": "4922",
	"./pw.svg": "2c71",
	"./py.svg": "cdf7",
	"./qa.svg": "9004",
	"./re.svg": "878f",
	"./ro.svg": "6e29",
	"./rs.svg": "98e1",
	"./ru.svg": "53f5",
	"./rw.svg": "cf39",
	"./sa.svg": "a63c",
	"./sb.svg": "c993",
	"./sc.svg": "58dd",
	"./sd.svg": "3439",
	"./se.svg": "20bf",
	"./sg.svg": "5e08",
	"./sh.svg": "b41f",
	"./si.svg": "046c",
	"./sj.svg": "6682",
	"./sk.svg": "b367",
	"./sl.svg": "53db",
	"./sm.svg": "1f95",
	"./sn.svg": "cbeb",
	"./so.svg": "8f65",
	"./sr.svg": "377c",
	"./ss.svg": "3c0a",
	"./st.svg": "ffa5",
	"./sv.svg": "4b7c",
	"./sx.svg": "3f9b",
	"./sy.svg": "b80d",
	"./sz.svg": "7b63",
	"./tc.svg": "7895",
	"./td.svg": "fe3c",
	"./tg.svg": "cd66",
	"./th.svg": "ce7a",
	"./tj.svg": "e35a",
	"./tk.svg": "2ed7",
	"./tl.svg": "9292",
	"./tm.svg": "1ba1",
	"./tn.svg": "65eb",
	"./to.svg": "1f02",
	"./tr.svg": "073e",
	"./tt.svg": "9025",
	"./tv.svg": "3b29",
	"./tw.svg": "40f0",
	"./tz.svg": "834b",
	"./ua.svg": "61ad",
	"./ug.svg": "40e3",
	"./us.svg": "8900",
	"./uy.svg": "9a3b",
	"./uz.svg": "9814",
	"./va.svg": "f61d",
	"./vc.svg": "6c17",
	"./ve.svg": "fda5",
	"./vg.svg": "d228",
	"./vi.svg": "64d3",
	"./vn.svg": "025d",
	"./vu.svg": "9225",
	"./wf.svg": "7a78",
	"./ws.svg": "cb29a",
	"./xk.svg": "8392",
	"./ye.svg": "1575",
	"./yt.svg": "16a7",
	"./za.svg": "e947",
	"./zm.svg": "972d",
	"./zw.svg": "67ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1c2";